import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import IpoAccordian from '../../../components/IpoAccordian';
import CustomTable from '../../../components/customTable/customTable';
import { subscriptionDetails } from '../../../api/IposApi';
import { formatDateWithDayNumber, formatIndianPrice, TABKEY } from '../../../components/CommonFunction';
import { useNavigate } from 'react-router-dom';
import useIsMobile576 from '../../../hooks/useIsMobile576'


export const SubscriptionDetails = ({ id, setIsLoading }) => {
    const navigate = useNavigate();
    const isMobile576 = useIsMobile576(576)

    const { ipoDetailData, ipoDetailLoading } = useSelector(state => state.ipoDetail);
    const [subscriptionData, setSubscriptionData] = useState({
        id: 1469,
        ipo_subscription_detail: [
            { times: 0, applied: 67361280, offered: 14519200, category: "QIB", total_amount: 583.67 },
            { times: 0, applied: 4307310, offered: 10889400, category: "NIB", total_amount: 437.75 },
            { times: 0, applied: 10540285, offered: 25408599, category: "RETAIL", total_amount: 1021.43 },
            { times: 0, applied: 425565, offered: 1579399, category: "EMPLOYEES", total_amount: 63.49 },
            { times: 0, applied: 2285955, offered: 7259600, category: "HNIs(10L +)", total_amount: 291.84 },
            { times: 0, applied: 2021355, offered: 3629800, category: "HNIs (2-10L)", total_amount: 145.92 },
            { times: 0, applied: 583940, offered: 1129574, category: "Shareholder", total_amount: 45.41 }
        ],
        updated_at: "2025-02-04T06:45:02.112580Z",
        ipo_reservation: [
            { no_of_shares: 25408599, shares_offered: 33.74, investor_category: "RETAIL", total_amount: 1021.43 },
            { no_of_shares: 10889400, shares_offered: 14.46, investor_category: "NII(HNI)", total_amount: 437.75 },
            { no_of_shares: 14519200, shares_offered: 19.28, investor_category: "QIB", total_amount: 583.67 },
            { no_of_shares: 1129574, shares_offered: 1.5, investor_category: "Shareholders", total_amount: 45.41 },
            { no_of_shares: 1579399, shares_offered: 2.1, investor_category: "Employees", total_amount: 63.49 }
        ],
        company_name: "Dr. Agarwals Health Care Limited",
        applications: 309355,
        is_encrypt: true,
        platform: "Android"
    });

    const [ipoOfferCol, setIpoOfferCol] = useState([
        {
            category: 'Anchor Investor',
            Shares_Offered: '2,17,78,798',
            Amount: '875.51',
            Size: '28.92%'
        },
        {
            category: 'Anchor Investor',
            Shares_Offered: '2,17,78,798',
            Amount: '875.51',
            Size: '28.92%'
        },
        {
            category: 'Anchor Investor',
            Shares_Offered: '2,17,78,798',
            Amount: '875.51',
            Size: '28.92%'
        },
    ])
    const [appRecived, setAppRecived] = useState([
        {
            category: 'Anchor Investor',
            applied: '10',
        },
    ])

    const [ipoDetailsCol, setIpoDetailsCol] = useState([])

    const columnCapitalinfra = [
        {
            title: "Category",
            dataIndex: "category",
            key: "category",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Shares Offered",
            dataIndex: "Shares_Offered",
            key: "Shares_Offered",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {formatIndianPrice(text)}
                </span>
            ),
        },
        {
            title: "Applied",
            dataIndex: "Shares_bid",
            key: "Shares_bid",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {formatIndianPrice(text)}
                </span>
            ),
        },
        {
            title: "Subscription (times)",
            dataIndex: "Subscription",
            key: "Subscription",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
    ];

    const columnIPOoffer = [
        {
            title: "Category",
            dataIndex: "category",
            key: "category",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Offered",
            dataIndex: "offered",
            key: "offered",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Demand",
            dataIndex: "demand",
            key: "demand",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Times",
            dataIndex: "times",
            key: "times",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
    ];

    const applicationCol = [
        {
            title: "Category",
            dataIndex: "category",
            key: "category",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "App Received",
            dataIndex: "applied",
            key: "applied",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
    ];

    const columnIPOoffer2222 = [
        {
            Header: "Percentage",
            accessor: "percentage"
        },
        {
            Header: "Interest Cost Per Share",
            accessor: "value"
        }
    ];

    const columnIPOoffer2 = [
        {
            title: "Percentage",
            dataIndex: "percentage",
            key: "percentage",
            width: "50%",
            align: "center", // Aligns text to the center in Ant Design tables
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "center", // Centers horizontally
                        alignItems: "center", // Centers vertically
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "center",
                        width: "100%", // Ensures full width for centering
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}%
                </span>
            ),
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
            width: "50%",
            align: "center", // Aligns text to the center in Ant Design tables
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "center", // Centers horizontally
                        alignItems: "center", // Centers vertically
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "center",
                        width: "100%",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    ₹{text.toFixed(2)}
                </span>
            ),
        },
    ];

    useEffect(() => {

        const formattedData = Array.isArray(ipoDetailData?.ipo_subscription_detail)
            ? ipoDetailData.ipo_subscription_detail.map(item => ({
                category: item?.category,
                Subscription: item?.applied && item?.offered ? (item.applied / item.offered).toFixed(2) : 0, // Calculate times
                Shares_Offered: item?.offered || 0,
                Shares_bid: item?.applied || 0,
                amount: item?.total_amount || 0,
            }))
            : [];


        const totalValues = formattedData.length > 0
            ? formattedData.reduce((total, item) => ({
                Subscription: Number(total.Subscription) + Number(item.Subscription || 0),
                Shares_Offered: Number(total.Shares_Offered) + Number(item.Shares_Offered || 0),
                Shares_bid: Number(total.Shares_bid) + Number(item.Shares_bid || 0),
                amount: Number(total.amount) + Number(item.amount || 0)
            }), { Subscription: 0, Shares_Offered: 0, Shares_bid: 0, amount: 0 })
            : { Subscription: 0, Shares_Offered: 0, Shares_bid: 0, amount: 0 };  // Default values

        totalValues.Subscription = totalValues.Shares_Offered
            ? (totalValues.Shares_bid / totalValues.Shares_Offered).toFixed(2)
            : "0.00";

        const finalFormattedData = [
            ...formattedData,
            {
                category: "Total",
                Subscription: totalValues.Subscription,
                Shares_Offered: formatIndianPrice(totalValues.Shares_Offered),
                Shares_bid: formatIndianPrice(totalValues.Shares_bid),
                amount: totalValues?.amount?.toFixed(2)
            }
        ];

        setIpoDetailsCol(finalFormattedData);

        let formattedDataReservation = ipoDetailData?.subscription_demand?.length > 0
            ? ipoDetailData?.subscription_demand?.map(item => ({
                category: item?.category,
                demand: Number(item?.demand) || 0, // Ensure numeric values
                offered: Number(item?.offered) || 0,
                times: item?.offered ? (Number(item.demand) / Number(item.offered)).toFixed(2) : "0.00" // Calculate times per row
            }))
            : [];

        const totalReservation = ipoDetailData?.subscription_demand?.length > 0
            ? ipoDetailData?.subscription_demand?.reduce((total, item) => ({
                demand: total.demand + (Number(item.demand) || 0),
                offered: total.offered + (Number(item.offered) || 0),
            }), { demand: 0, offered: 0 }) // Remove times from reduce (we calculate it later)
            : { demand: 0, offered: 0 };

        // Calculate total times as total demand / total offered
        totalReservation.times = totalReservation.offered
            ? (totalReservation.demand / totalReservation.offered).toFixed(2)
            : "0.00";

        let finalReservation = [
            ...formattedDataReservation,
            {
                category: "Total",
                demand: totalReservation?.demand,
                offered: totalReservation?.offered?.toFixed(2),
                times: totalReservation?.times // Already calculated above
            }
        ];
        setIpoOfferCol(finalReservation);

        const applicationData = ipoDetailData?.appplication_wise_breakup?.data?.length > 1
            ? ipoDetailData?.appplication_wise_breakup?.data?.slice(1)?.map(item => ({
                category: item?.category,
                applied: formatIndianPrice(parseInt(item?.applied, 10)),
                appliedd: parseInt(item?.applied, 10)

            })) : [];

        const totalApplication = applicationData?.length > 0 ? applicationData.reduce((total, item) => ({
            appliedd: (parseInt(total.appliedd, 10) || 0) + (parseInt(item.appliedd, 10) || 0)
        }), { appliedd: 0 }) : { appliedd: 0 };

        const finalApplication = [
            ...applicationData,
            {
                category: "Total",
                applied: formatIndianPrice(totalApplication?.appliedd),
            }
        ];

        setAppRecived(finalApplication);

    }, [subscriptionData, ipoDetailData])

    const companyName = ipoDetailData?.company_name?.split(" ")?.slice(0, 2)?.join(" ") + " IPO";

    return (
        <>
            <div className='mainDetailsPage'>
                <div className='content'>
                    <p>
                        {ipoDetailData?.company_name || ''} IPO subscribed {formatIndianPrice(ipoDetailData?.s_hni_subscription)} times. The public issue subscribed {ipoDetailData?.s_hni_subscription} times in the retail category, {ipoDetailData?.retail} times in QIB, and {ipoDetailData?.nii
                        } times in the NII category by {formatDateWithDayNumber(ipoDetailData?.updated_at)}.
                    </p>
                </div>

                <div className='content-box'>
                    <div className="flex flex-wrap xl:space-x-6 ">
                        {ipoDetailData?.ipo_subscription_detail?.length > 0 && (<>
                            <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                                <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                    <span className="text-sm text-slate-600 font-medium header_blog_span">
                                        {companyName} Subscription Details (No. of Shares)
                                    </span>
                                </div>
                                <div className="">
                                    {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
                            {capitalInfra?.description}
                        </h5> */}
                                    <div className="table-wraper">
                                        <CustomTable
                                            className="ipo_blog_table prospect"
                                            columns={columnCapitalinfra}
                                            data={ipoDetailsCol}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>)}


                        <div className=''>
                            {/* <h3>
                                Note :
                            </h3> */}
                            <div className='md:p-2 md:ms-3'>
                                <p>
                                    <span>Note : </span>"Shares Offered" and "Total Amount" are calculated based on the upper price of the issue price range.
                                </p>
                                {/* <p>
                                    **: The portion of anchor investors (or market makers) is not included in the total number of shares offered.
                                </p> */}
                            </div>
                        </div>

                        {/*---------------------- allotment_ipo ------------------------------ */}

                        {/* <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                            <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                <span className="text-sm text-slate-600 font-medium header_blog_span">
                                    {ipoDetailData?.company_name} IPO (Day-wise) Subscription Details (times)

                                </span>
                            </div>

                            <div className='content-text'>
                                <p >
                                    Investors can bid for a minimum of 150 shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
                                </p>
                            </div>
                            <div className="">

                                <div className="table-wraper">
                                    <CustomTable
                                        className="ipo_blog_table prospect"
                                        columns={columnInvitLotSize}
                                        data={lotSizeCol}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>

                <hr></hr>

                <section className='content-description content-box'>

                    {ipoDetailData?.subscription_demand?.length > 0 && (<div className="flex flex-wrap xl:space-x-6 ">
                        <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                            <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                <span className="text-sm text-slate-600 font-medium header_blog_span">
                                    {companyName} Subscription Demand (in ₹ Crore)
                                </span>
                            </div>
                            <div className="">
                                {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
                            {capitalInfra?.description}
                        </h5> */}
                                <div className="table-wraper">
                                    <CustomTable
                                        className="ipo_blog_table prospect"
                                        columns={columnIPOoffer}
                                        data={ipoOfferCol}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>)}

                    <div className="flex gap-4">
                        {ipoDetailData?.interest_cost_per_share?.map((offer, index) => (
                            <div
                                key={index}
                                className="relative  my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto"
                            >
                                <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                    <span className="text-sm text-slate-600 font-medium header_blog_span">
                                        {offer.title}
                                    </span>
                                </div>
                                <div className="table-wraper">
                                    <CustomTable
                                        className="ipo_blog_table prospect"
                                        columns={columnIPOoffer2}
                                        data={offer.interest_cost_per_share_data}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    {ipoDetailData?.appplication_wise_breakup?.data?.length > 1 && ipoDetailData?.appplication_wise_breakup?.data?.length != "" &&
                        <div className="flex flex-wrap xl:space-x-6 ">
                            <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                                <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                    <span className="text-sm text-slate-600 font-medium header_blog_span">
                                        {companyName} Application Wise Breakup(Approx. no of Apps)
                                    </span>
                                </div>
                                <div className="">
                                    {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
     {capitalInfra?.description}
 </h5> */}
                                    <div className="table-wraper">
                                        <CustomTable
                                            className="ipo_blog_table prospect"
                                            columns={applicationCol}
                                            data={appRecived}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>}
                    <hr></hr>

                    {/* {
                        ipoDetailData?.about_the_company && (
                            <div className='mt-4 mb-5'>
                                <h3>
                                    IPO Investor Categories
                                </h3>
                                <div>
                                    <p >
                                        {ipoDetailData?.about_the_company}
                                    </p>
                                    <hr></hr>
                                </div>
                            </div>
                        )
                    } */}

                    {
                        ipoDetailData?.issue_objectives !== "NA" || ipoDetailData?.issue_objectives && (<>

                            <div className='my-2 md:mt-4 md:mb-5'>
                                <h3>
                                    {companyName} Investor Categories
                                </h3>
                                <div>
                                    <ul className='list-disc pl-5'>
                                        <li className='list-none'>The Offer Proceeds will be utilised towards the following objects:</li>
                                        <li>
                                            Qualified Institutional Buyers (QIB)
                                            <p className='list-disc-description mt-2 pb-0'>Financial Institutions, Banks, FIIs, and Mutual Funds registered with SEBI are called QIBs. In most cases, QIBs represent small investors who invest through mutual funds, ULIP schemes of insurance companies, and pension schemes.</p>
                                        </li>

                                        <li>
                                            Non-Institutional Investors (NII)
                                            <p className='list-disc-description mt-2'>Retail Individual Investors (HNI), NRIs, Companies, Trusts, etc. who bid for shares worth more than Rs 2 lakhs are known as Non-institutional bidders (NII). Unlike QIB bidders, they do not need SEBI registration.</p>
                                            <p className='mt-2 font-bold'>NII category has two subcategories:</p>
                                            <ul className="list-decimal mt-2 ms-5">
                                                <li>
                                                    sNII (bids below Rs 10L)
                                                    <p className='mt-2'>The Small NII category is for NII investors who bid for shares between Rs 2 lakhs to Rs 10 lakhs. 1/3 of NII category shares are reserved for the Small NII sub-category. This subcategory is also known as Small HNI (sHNI).</p>
                                                </li>
                                                <li>
                                                    bNII (bids above Rs 10L)
                                                    <p className='mt-2'>The Big NII category is for NII investors who bid for shares worth more than Rs 10 Lakhs. 2/3 of NII category shares are reserved for the Big NII subcategory. This subcategory is also known as Big HNI (bHNI).</p>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            Retail Individual Investors (RII)
                                            <p className='mt-2'>The retail individual investor or NRIs who apply up to Rs 2 lakhs in an IPO are considered as RII reserved category.
                                            </p>
                                        </li>
                                        <li>
                                            Employee (EMP)
                                            <p className='mt-2'>A category of eligible employees who have a reserved quota in the IPO.

                                            </p>
                                        </li>
                                        <li>
                                            Others
                                            <p className='mt-2'>
                                                A category of eligible shareholders or other investors who have a reserved quota in the IPO.
                                            </p>
                                        </li>
                                    </ul>
                                    <hr></hr>
                                </div>
                            </div>
                        </>)
                    }

                    {/* <div className='mt-4 mb-5 '>
                <div className="row content-details">
                    <div className="col-md-6">
                        <div className="content-details-description">
                            <div className='content-header'>
                            <h4>Capital Infra Trust Contact Details</h4>
                            </div>
                            <div className="">
                                <h5>Capital Infra Trust</h5>
                                <p>Unit No. 1401-1403, 14th Floor, Tower B, SAS Tower, Medicity, Sector-38-Gurugram-122001</p>
                                <hr />
                                <div className='mt-4 ms-3'>
                                    <div className="content-details-label">
                                        <label>Phone :</label>
                                        <p className='ps-2'>+0124 4920139</p>
                                    </div>
                                    <div className="content-details-label">
                                        <label>Email: :</label>
                                        <p className='ps-2'>compliance@capitalinfratrust.com</p>
                                    </div>
                                    <div className="content-details-label">
                                        <label>Website: :</label>
                                        <p className='ps-2'>https://www.capitalinfratrust.com/</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="content-details-description">
                            <h4>Capital Infra Trust Contact Details</h4>
                            <div className="">
                                <h5>Capital Infra Trust</h5>
                               
                                <div className='mt-4 ms-3'>
                                    <div className="content-details-label">
                                        <label>Phone :</label>
                                        <p className='ps-2'>+0124 4920139</p>
                                    </div>
                                    <div className="content-details-label">
                                        <label>Email: :</label>
                                        <p className='ps-2'>compliance@capitalinfratrust.com</p>
                                    </div>
                                    <div className="content-details-label">
                                        <label>Website: :</label>
                                        <p className='ps-2'>https://www.capitalinfratrust.com/</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

                    {!isMobile576 &&
                        <h3>
                            {companyName} FAQs
                        </h3>
                    }
                </section>

                {!isMobile576 &&
                    <div className='mt-4 mb-5'>
                        <IpoAccordian ipoDetailData={ipoDetailData} />
                    </div>
                }
            </div>
        </>
    )
}
